/* eslint-disable no-underscore-dangle */

define([
  'axios',
  'js-cookie',
  'es6!launcher/util/discounts/ecommerce',
], (
  axios, jscookie, EcommerceUtil,
) => {
  const VALID_UTM_CAMPAIGN_PREFIXES = [
    'sumo-convert-window-shopper',
    'sumo-customer-outreach',
    'sumo-email',
  ];

  const queryStringParser = (str) => {
    if (!str) return {};

    const queryString = str.substr(1).split('&');
    if (queryString === '') return {};

    const queryDict = {};
    for (let i = 0; i < queryString.length; i += 1) {
      const p = queryString[i].split('=', 2);

      if (p.length === 1) {
        queryDict[p[0]] = '';
      } else {
        try {
          queryDict[p[0]] = decodeURIComponent(p[1].replace(/\+/g, ' '));
        } catch (e) {
          queryDict[p[0]] = p[1].replace(/\+/g, ' ');
        }
      }
    }

    return queryDict;
  };

  const setCartAttributes = attributes => (
    axios({
      method: 'post',
      url: '/cart/update.js',
      data: {
        attributes,
      },
    }).catch(() => {
      /* noop */
    })
  );

  return {
    processShopifyParams() {
      const query = queryStringParser(window.location.search) || {};

      const hasValidQuery = (() => {
        for (let i = 0; i < VALID_UTM_CAMPAIGN_PREFIXES.length; i += 1) {
          if (query.utm_campaign.indexOf(VALID_UTM_CAMPAIGN_PREFIXES[i]) === 0) {
            return true;
          }
        }

        return false;
      })();

      if (!hasValidQuery) return;

      const attributes = {};

      if (query.sumo_shortcut_id) {
        attributes['Sumo Shortcut ID'] = query.sumo_shortcut_id;
      }

      if (query.sumo_email_campaign_id) {
        attributes['Sumo Email Campaign ID'] = query.sumo_email_campaign_id;
      }

      if (query.sumo_email_id) {
        attributes['Sumo Email ID'] = query.sumo_email_id;
      }

      if (Object.keys(attributes).length) setCartAttributes(attributes);
    },

    autoApplyDiscounts() {
      const query = queryStringParser(window.location.search) || {};

      Object.keys(query).forEach((key) => {
        if (/^discount-[0-9a-fA-F]{8}$/.test(key)) {
          const discount = query[key];

          if (discount && discount.trim()) {
            EcommerceUtil.shopify.applyDiscount(discount.trim());
          }
        }
      });
    },

    logExistingUserAsSubscriber(opts = {}) {
      const { sumoUrl, visitorId, siteId } = opts;
      if (!sumoUrl || !visitorId || !siteId) return;

      const shopifyCustomer = window.__sumoShopify && window.__sumoShopify.customer;
      if (visitorId && shopifyCustomer && shopifyCustomer.email && !jscookie.get('__smSubscribed')) {
        // Subscribe!
        const data = {
          site_id: siteId,
          visitor_id: visitorId,
          email_address: shopifyCustomer.email,
          customer_id: shopifyCustomer.id,
        };

        axios.post(`${sumoUrl}/list/subscribe`, data, {
          withCredentials: false,
          headers: {
            'X-Sumo-Auth': jscookie.get('__smToken'),
          },
        }).then((response) => {
          if (response.data && response.data.success) {
            // Set subscribed cookie
            const d = new Date();
            d.setFullYear(d.getFullYear() + 10);
            jscookie.set('__smSubscribed', true, { expires: d, path: '/' });
          }
        });
      }
    },
  };
});
